import { BudgetMonthData } from '../types';

/**
 * Optimistically patch a category's budgeted amount and roll up group/month totals.
 */
export function patchCategoryBudgetInMonth(
  month: BudgetMonthData,
  categoryId: string,
  amountCents: number
): BudgetMonthData {
  let delta = 0;

  const categoryGroups = month.categoryGroups.map(group => {
    let groupDelta = 0;
    const categories = group.categories.map(cat => {
      if (cat.id !== categoryId) return cat;
      const oldBudgeted = cat.budgeted ?? 0;
      groupDelta = amountCents - oldBudgeted;
      return {
        ...cat,
        budgeted: amountCents,
        balance: (cat.balance ?? 0) + groupDelta
      };
    });

    if (groupDelta === 0) return group;
    delta = groupDelta;

    return {
      ...group,
      categories,
      budgeted: (group.budgeted ?? 0) + groupDelta,
      balance: (group.balance ?? 0) + groupDelta
    };
  });

  if (delta === 0) return month;

  return {
    ...month,
    totalBudgeted: (month.totalBudgeted ?? 0) + delta,
    toBudget: (month.toBudget ?? 0) - delta,
    totalBalance: (month.totalBalance ?? 0) + delta,
    categoryGroups
  };
}
